import { EMPTY, throwError } from 'rxjs';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpClient,
  HttpErrorResponse,
  HttpResponse
} from '../../node_modules/@angular/common/http';
import { Observable } from '../../node_modules/rxjs';
import {
  catchError,
  tap,
  take,
  switchMap,
  map,
  skipWhile,
  finalize
} from '../../node_modules/rxjs/operators';
import { Configuration } from '../app/conf/app.constants';
import { TokenService } from '../app/token.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SessionInfo } from '../app/api/UserPrefs-dto';
import { NonStaticInterceptor } from './nonstatic.http-interceptor';
import { Injectable } from '@angular/core';
import { AuthService } from '../app/auth.service';


@Injectable()
export class JwtHttpInterceptor extends NonStaticInterceptor implements HttpInterceptor {
  private jwtHelper: JwtHelperService = new JwtHelperService();
  private sessionRefreshsingObservable: Observable<boolean>;

  constructor(
    private authService: AuthService,
    private _http: HttpClient,
    private _configuration: Configuration,
    private tokenService: TokenService
  ) {
    super();
    this.sessionRefreshsingObservable = this.tokenService.getSessionRefreshingObservable();
  }

  protected internalIntercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let accessToken = this.tokenService.getAccessToken();
    return next.handle(this.addToken(req, accessToken)).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          if (req.url === this._configuration.ServerWithPublicApiUrl + '/auth/refresh') {
            this.catchRefreshError();
            return throwError(error);
          }
          switch ((<HttpErrorResponse>error).status) {
            case 401:
              return this.handle401Error(req, next, accessToken);
            case 403: {
              if (req.url === this._configuration.ServerWithAuthApiUrl + 'auth/logout'
                || req.url === this._configuration.ServerWithAuthApiUrl + 'sso/logout') {
                // limpiar sesion
                this.authService.cleanSessionInfo();
              }
            }
            // tslint:disable-next-line:no-switch-case-fall-through
            default:
              return throwError(error);
          }
        } else {
          return throwError(error);
        }
      })
    );
  }

  private catchRefreshError() {
    // quitamos el flag para liberar peticiones pausadas
    console.log('Error, no es posible refrescar el token');
    this.tokenService.setRefreshingToken(false);
    if (!this.authService.requires2FA()) {
      // limpiar sesion solo si no hay 2FA y el usuario no está autenticado (pagina 2FA)
      this.authService.exit();
    }
  }

  private addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    let reqHeaders = req.headers;
    if (token) {

      // el nombre de la cabecera de seguridad se calcula en servidor y viaja en el token de seguridad
      let authHeaderName = this.tokenService.getAuthHaderName();

      // Si se aplica el token de seguridad en una cabecera alternativa, si existe la cabecera Authorization la borramos
      if (authHeaderName.toLowerCase() !== 'authorization') {
        const headerKeys = reqHeaders.keys();
        const headerKeyToRemove = headerKeys.find((key) => key.toLowerCase() === 'authorization');
        if (headerKeyToRemove) {
          reqHeaders = reqHeaders.delete(headerKeyToRemove);
        }
      }

      reqHeaders = reqHeaders.set(authHeaderName, 'Bearer ' + token);
      return req.clone({
        headers: reqHeaders
      });
    } else {
      return req;
    }
  }

  private handle401Error(req: HttpRequest<any>, next: HttpHandler, actualToken: string): Observable<HttpEvent<any>> {
    if (this.tokenService.isSessionRefreshing()) {
      // si se está refrescando token esperar a respuesta
      console.log('Operacion pausada en espera renovacion autorizacion ', req);
      // devolver operacion que se ejecuta al subscribirse a la recepcion del token de autorizacion para ejecutar de nuevo operacion
      return this.sessionRefreshsingObservable.pipe(
        skipWhile((refreshing: any) => refreshing === true || refreshing === 'true'),
        take(1),
        switchMap((refreshing: boolean) => {
          console.log('Reejecutando ', refreshing, !refreshing)
          let accessToken = this.tokenService.getAccessToken();
          if (accessToken) {
            console.log('Reejecutando operacion con token renovado ', req);
            return next.handle(this.addToken(req, accessToken));
          } else {
            return throwError('Sesion expirada');
          }
        })
      )
    } else {
      let accessToken = this.tokenService.getAccessToken();
      if (actualToken !== accessToken) {
        // reintentar, otro proceso ha cambiado el token
        console.log('Reintentar operacion otro proceso cambio el token');
        return this.internalIntercept(req, next);
      } else if (this.refreshTokenValid()) {
        // renovar
        this.tokenService.setRefreshingToken(true);
        console.log('Primera operacion invalida con token de refresco valido.',
          'Renovando autorizacion y estableciendo flag operacion de refresco en curso ', req);
        return this.renewAuth().pipe(
          switchMap((session: SessionInfo) => {
            let newToken = session.accessToken;
            // emitir nuevo token para continuar resto de peticiones pausadas
            console.log('Avisando token renovado a resto de operaciones pausadas');
            console.log('Re-ejecutando primera operacion invalida con token renovado');
            return next.handle(this.addToken(req, newToken)).pipe(
              finalize(() => this.tokenService.setRefreshingToken(false))
            );
          })
        );
      } else {
        // salir
        console.log('Token de refresco invalido limpiando sesion para peticion ', req);
        this.authService.logout();
        return throwError('Sesion expirada');
      }
    }
  }

  private refreshTokenValid(): boolean {
    // console.log('is refresh token valid...');
    // let valid = false;
    // if (this.tokenService.getRefreshToken()) {
    //   let jwtExp: number = this.jwtHelper.decodeToken(
    //     this.tokenService.getRefreshToken()
    //   ).exp;
    //   let exp: Date = new Date(0);
    //   exp.setUTCSeconds(jwtExp);
    //   let now: number = new Date().valueOf();
    //   valid = exp.valueOf() > now;
    // }
    // console.log('is refresh token valid=' + valid);
    // return valid;
    return this.tokenService.getRefreshToken() !== undefined;
  }

  public renewAuth(verificationCode?: string): Observable<SessionInfo> {
    // let credsObject: any;
    // Get a new JWT using the refresh token saved
    // in local storage
    let refreshToken = this.tokenService.getRefreshToken();
    if (refreshToken) {
      console.log('renew with refreshToken' + refreshToken);
      let credsObject = {
        refreshToken: this.tokenService.getRefreshToken(),
        userName: this.jwtHelper.decodeToken(refreshToken)['sub'],
        verificationCode: verificationCode
      };
      let actionUrl = this._configuration.ServerWithPublicApiUrl + 'auth/refresh';
      let observable: Observable<any>;
      if (verificationCode) {
        observable = this._http.post<SessionInfo>(actionUrl, JSON.stringify(credsObject), { observe: 'response' }).pipe(
          map((response: HttpResponse<SessionInfo>) => response.body),
        );
      } else {
        observable = this._http.post<SessionInfo>(actionUrl, JSON.stringify(credsObject));
      }
      return observable.pipe(
        tap((sessionInfo: SessionInfo) => this.tokenService.setSessionInfo(sessionInfo)),
        catchError((error: any) => {
          this.catchRefreshError();
          return throwError(error);
        })
      );
    } else {
      return EMPTY;
    }
  }

}
